import type { ImplementedLocale } from '../../shared'

export const competitionNameMessages = {
  'en': {
    'copa_america': 'Copa America',
    'euro': 'Euro',
    'friendlies': 'Friendlies',
    'nations_league': 'Nations League',
    'premier_league': 'Premier League',
    'champions_league': 'UEFA Champions League',
    'world_cup': 'World Cup',
    'world_cup_qualifier': 'World Cup qualifiers',
    'Copa America': 'Copa America',
    'Euro Championship': 'Euro',
    'FIFA World Cup': 'World Cup',
    'UEFA Nations League': 'Nations League',
    'World Cup Qualification': 'World Cup qualifiers',
    'World Cup Qualification AFC': 'World Cup qualifiers AFC',
    'World Cup Qualification CAF': 'World Cup qualifiers CAF',
    'World Cup Qualification CONCACAF': 'World Cup qualifiers CONCACAF',
    'World Cup Qualification CONMEBOL': 'World Cup qualifiers CONMEBOL',
    'World Cup Qualification OFC': 'World Cup qualifiers OFC',
    'World Cup Qualification UEFA': 'World Cup qualifiers UEFA',
  },
  'zh-CN': {
    'copa_america': '美洲杯',
    'euro': '欧洲杯',
    'friendlies': '友谊赛',
    'nations_league': '欧国联',
    'premier_league': '英超',
    'champions_league': '欧冠',
    'world_cup': '世界杯',
    'world_cup_qualifier': '世界杯预选赛',
    'Copa America': '美洲杯',
    'Euro Championship': '欧洲杯',
    'FIFA World Cup': '世界杯',
    'UEFA Nations League': '欧国联',
    'World Cup Qualification': '世界杯预选赛',
    'World Cup Qualification AFC': '世界杯预选赛亚洲区',
    'World Cup Qualification CAF': '世界杯预选赛非洲区',
    'World Cup Qualification CONCACAF': '世界杯预选赛中北美及加勒比区',
    'World Cup Qualification CONMEBOL': '世界杯预选赛南美区',
    'World Cup Qualification OFC': '世界杯预选赛大洋洲区',
    'World Cup Qualification UEFA': '世界杯预选赛欧洲区',
  },
} as const

export function formatCompetitionName(name: string | null | undefined, locale: ImplementedLocale) {
  if (!name)
    return ''
  return competitionNameMessages[locale]?.[name as keyof typeof competitionNameMessages.en]
    ?? competitionNameMessages.en[name as keyof typeof competitionNameMessages.en]
    ?? name
}

export const formatCompetitionCode = formatCompetitionName
